import React, { Component } from 'react';
import { Button, TextField, Toolbar } from 'react-md';
import '../Wizard.scss';
import { ProgressBar } from '../../index';

export default class PersonWizardStep1 extends Component {
  state = {
    firstName: '',
    lastName: ''
  }

  componentDidMount() {
    const { data, relationships ,actions: { getOrganizations } } = this.props;

    if (relationships.length < 1) {
      getOrganizations();
    }

    if (data) {
      this.setState({
        firstName: data.firstName,
        lastName: data.lastName
      });
    }
  }

  handleFirstNameChange = (data) => {
    this.setState({ firstName: data });
    this.props.actions.update({ firstName: data });
  }

  handleLastNameChange = (data) => {
    this.setState({ lastName: data });
    this.props.actions.update({ lastName: data });
  }

  render() {
    const { firstName, lastName } = this.state;
    const { data, title, hide } = this.props;

    return (
      <div className="wrapper">
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: '36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" icon onClick={hide}>arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} steps={data ? 3 : 4} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">What’s their full name?</div>
          </div>
          <div className="wizard-text-multi-input-container">
            <TextField
              id="person-first-name-input"
              className="wizard-text-input"
              label="First Name"
              value={firstName}
              onChange={(v) => this.handleFirstNameChange(v)}
            />
            <TextField
              id="person-last-name-input"
              className="wizard-text-input"
              label="Last Name"
              value={lastName}
              onChange={(v) => this.handleLastNameChange(v)}
            />
          </div>
          <div><Button className="wizard-button" disabled={!firstName || !lastName} flat onClick={this.props.nextStep} children="continue" /></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/PersonWizardStep1/PersonWizardStep1.jsx